// The physics of PrismPixel™ — the behaviour of light refracting through heavy
// glass. Imported ONLY by root (/) homepage components; never by sub-pages, so
// nothing outside the homepage is affected.

// Custom easing curves — framer arrays and matching CSS strings.
// settle:  light emerging into the void — a deliberate, graceful entry that
//          decelerates into an almost infinite settle.
// refract: travel through the pane — a symmetric ease-in-out.
// bloom:   accents blooming with the faintest whisper of overshoot.
export const GLASS = {
  settle: [0.22, 1, 0.36, 1],
  refract: [0.65, 0, 0.35, 1],
  bloom: [0.34, 1.18, 0.64, 1],
};

export const GLASS_CSS = {
  settle: "cubic-bezier(0.22, 1, 0.36, 1)",
  refract: "cubic-bezier(0.65, 0, 0.35, 1)",
};

// Golden-ratio vertical rhythm (φ = 1.618), fluid via clamp so the void scales
// with the viewport and the typography always has room to breathe.
export const PHI = {
  s1: "clamp(0.618rem, 1.4vw, 1rem)",
  s2: "clamp(1rem, 2.4vw, 1.618rem)",
  s3: "clamp(1.618rem, 4vw, 2.618rem)",
  s4: "clamp(2.618rem, 6.2vw, 4.236rem)",
  s5: "clamp(4.236rem, 9.4vw, 6.854rem)",
  s6: "clamp(6.854rem, 14vw, 11.089rem)",
};

// Fluid typography — a quiet, authoritative whisper across every viewport.
export const TYPE = {
  display: "clamp(3.25rem, 7.4vw, 6.25rem)",
  wordmark: "clamp(2.25rem, 5.6vw, 4.25rem)",
  h2: "clamp(1.875rem, 5vw, 3.25rem)",
  lead: "clamp(1.125rem, 1.9vw, 1.5rem)",
  body: "clamp(1rem, 1.35vw, 1.1875rem)",
  small: "clamp(0.8125rem, 1vw, 0.875rem)",
};

// Sub-diffuse luminous depth — extremely low-opacity glows that suspend elements
// at different depths along the Z-axis of the dark canvas.
export const GLOW = {
  silver: "0 0 44px rgba(245, 245, 247,0.055)",
  silverSoft: "0 0 30px rgba(245, 245, 247,0.04)",
  gold: "0 0 36px rgba(132,223,244,0.11)",
  suspend: "0 26px 70px -30px rgba(0,0,0,0.9), 0 0 60px -20px rgba(132,223,244,0.06)",
};

// Swap any reveal() preset's easing for the glass settle while keeping its
// viewport trigger untouched.
export const glassReveal = (r) => ({
  ...r,
  transition: { ...r.transition, ease: GLASS.settle },
});
